

<div class="container-fluid"> 
    <app-measures-table></app-measures-table>
</div>

<div *ngIf="this.showMeasureDetails$ | async">

    <div class="container-fluid">  
        
        <form [formGroup] = "measuresForm" [connectForm]="form$ | async">
            <div class="measures-row">
                <mat-form-field class="measures-field">
                    <mat-label>Title</mat-label>
                    <input matInput formControlName="title">
                </mat-form-field>
            </div>
        
            <div class="measures-row">
                <mat-form-field class="measures-field">
                    <mat-label>Description</mat-label>
                    <textarea  matInput formControlName="description"></textarea>
                </mat-form-field>
            </div>
        
            <div class="measures-group">
                <mat-form-field class="measures-group-itmem">
                    <mat-label>ECQM</mat-label>
                    <input matInput formControlName="eMeasure_Measure_identifier">
                </mat-form-field>
        
                <mat-form-field class="measures-group-itmem">
                    <mat-label>QPP</mat-label>
                    <input matInput formControlName="qpP_identifier">
                </mat-form-field>
              
                <mat-form-field class="measures-group-itmem">
                    <mat-label>Type</mat-label>
                    <mat-select formControlName="measureTypeID">
                        <mat-option *ngFor="let option of this.typesList$ | async" [value]="option.id">
                            {{ option.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
               
                <mat-checkbox formControlName="highPriority" class="measures-group-itmem">Priority</mat-checkbox>
               
            </div>
            <div class="measures-row" *ngIf="false">
                <button mat-button (click)="saveMeasureData()">Save</button>
            </div>
            
        </form>
    </div>

    <div class="container-fluid">    
        <h3 mat-subheader>Population Criteria</h3>
        <button mat-button (click)="addNewPopulation()" *ngIf="canAddCriteria$ | async">Add New</button>
        <div cdkDropList (cdkDropListDropped)="drop($event)">
           
            @for (criteria of this.measureDetail$ | async; track criteria; let index = $index) {
                <mat-accordion multi cdkDrag class="container-fluid" >
                    <mat-expansion-panel>                    
                        <mat-expansion-panel-header>
                        {{ criteria.name }}
                        </mat-expansion-panel-header>
                    
                        <ng-template matExpansionPanelContent>
                            <app-measure-components [criteriaId]="criteria.id" [components]="criteria.components"></app-measure-components>
                        </ng-template>
                    </mat-expansion-panel>
                </mat-accordion>
            }          
        </div>
    </div>  
    
</div>